import type { IIsMobilePlatformInjectedProps } from '@/types/composables/useIsMobilePlatform';
import { IS_MOBILE_PLATFORM_INJECT_KEY } from '@/types/composables/useIsMobilePlatform.const';
import { computed, inject, provide } from 'vue';
import { useDisplay } from 'vuetify/lib/composables/display.mjs';

const useIsMobilePlatform = () => {
  const provideIsMobilePlatform = (): IIsMobilePlatformInjectedProps => {
    const display = useDisplay();
    const isMobilePlatform = computed(() => {
      if (display.platform.value.android) {
        return true;
      }
      if (display.platform.value.ios) {
        if (navigator.userAgent.includes('iPhone')) {
          return true;
        }
      }
      return false;
    });

    const data: IIsMobilePlatformInjectedProps = {
      isMobilePlatform
    };

    provide(IS_MOBILE_PLATFORM_INJECT_KEY, data);

    return data;
  };

  const injectIsMobilePlatform = () => {
    const isMobilePlatformInjectedProps = inject<IIsMobilePlatformInjectedProps>(
      IS_MOBILE_PLATFORM_INJECT_KEY
    );
    if (!isMobilePlatformInjectedProps) {
      throw new Error('[UseIsMobilePlatform] Mobile platform props are not provided');
    }
    return isMobilePlatformInjectedProps;
  };

  return { provideIsMobilePlatform, injectIsMobilePlatform };
};

export default useIsMobilePlatform;
